<div class="container p-4" style="    max-width: 1320px;">
    <div class="card">


        <div >
            <div class="text-center m-auto" style="max-width: 500px;margin: auto;">

                <i class="la la-times-circle" style="font-size: 80px;color:#8c1a1a;margin-bottom: 10px;"></i>
                <h3>Payment Canceled</h3>
                <br>


            </div>

        </div>


    </div>


</div>

